<script setup lang="ts">
const releases = [
  {
    title: "Candy for Breakfast",
    artist: "Wet Set",
    description:
      "Groove-forward, unhurried, anchored by a dry female vocal that sits in the room like morning light.",
    coverArt: "/images/placeholder-release-cover.webp",
    to: "/music/candy-for-breakfast",
  },
];
</script>

<template>
  <main class="bg-page pt-[72px]">
    <!-- HERO -->
    <section
      class="bg-dark w-full flex items-center justify-center min-h-[40vh] md:min-h-[50vh] px-4"
    >
      <div class="flex flex-col items-center justify-center gap-6 text-center">
        <div class="flex flex-col items-center gap-3">
          <div class="h-px w-16 bg-brand/40" />
          <p
            class="font-label font-light text-xs uppercase tracking-[5px] text-brand"
          >
            WET WATER MUSIC
          </p>
          <div class="h-px w-16 bg-brand/40" />
        </div>
        <h1
          class="font-serif text-6xl md:text-8xl uppercase text-inverse leading-none"
        >
          MUSIC
        </h1>
        <p class="font-sans text-sm text-inverse opacity-60 max-w-md">
          Original music, film, and sound from the Wet Water world.
        </p>
      </div>
    </section>

    <!-- FEATURED RELEASE -->
    <section class="w-full py-16 md:py-24 px-4 md:px-[60px]">
      <div class="max-w-7xl mx-auto">
        <div
          v-for="release in releases"
          :key="release.to"
          class="flex flex-col md:flex-row gap-8 md:gap-16 items-start"
        >
          <div class="w-full md:w-auto md:flex-shrink-0 max-w-sm">
            <div class="aspect-square w-full overflow-hidden bg-raised">
              <img
                :src="release.coverArt"
                :alt="`${release.title} cover artwork`"
                class="w-full h-full object-cover"
              />
            </div>
          </div>
          <div
            class="flex flex-col gap-4 md:gap-6 flex-1 md:self-center max-w-prose"
          >
            <div class="flex flex-col gap-3">
              <p
                class="font-label font-light text-xs uppercase tracking-[5px] text-brand"
              >
                LATEST RELEASE
              </p>
              <div class="h-px w-full bg-stroke" />
            </div>
            <h2 class="font-serif text-4xl md:text-5xl text-dark">
              {{ release.title }}
            </h2>
            <p class="font-sans text-sm text-secondary">
              {{ release.artist }}
            </p>
            <p
              class="font-sans text-sm md:text-base text-dark leading-relaxed"
            >
              {{ release.description }}
            </p>
            <NuxtLink
              :to="release.to"
              class="font-label uppercase text-brand tracking-wider text-sm inline-flex items-center gap-2 hover:opacity-70 transition-opacity duration-200 w-fit"
            >
              Listen
              <span aria-hidden="true">→</span>
            </NuxtLink>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>
